/**
 * Settings landing page. Hosts the language switcher (moved out of
 * TopBar in PR23 — single point of truth for cosmetic profile prefs)
 * and the change-password link. Future user prefs land here.
 */
import { useTranslation } from "react-i18next";
import { Link } from "@tanstack/react-router";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { AppShell } from "@/layout/AppShell";
import { LocaleSwitcher } from "@/layout/LocaleSwitcher";

export function SettingsPage(): React.ReactElement {
  const { t } = useTranslation();
  return (
    <AppShell>
      <Card className="max-w-md">
        <CardHeader>
          <CardTitle>{t("settings.title")}</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4 text-sm">
          <div className="flex items-center justify-between gap-3">
            <span className="text-muted-foreground">{t("settings.language")}</span>
            <LocaleSwitcher />
          </div>
          <Link to="/settings/change-password" className="text-primary underline">
            {t("settings.changePasswordLink")}
          </Link>
        </CardContent>
      </Card>
    </AppShell>
  );
}
